export default "__VITE_ASSET__Chn51CQ0__"